import { definePermission } from "./permission";
/**
 * The support and trainer axis (`D52`).
 *
 * `workout:read` — your own — is not here and never will be: your own training
 * data needs no grant. A trainer reads a student's through MEMBERSHIP (`D50`),
 * read from the database when a request names a group, not from the token.
 * This permission is the platform-wide one, above every group: support.
 */
export const WORKOUT_READ_ALL = definePermission("workout:read:all", "Read any account's training data, for support.");
export const SUPPORT_PERMISSIONS = [WORKOUT_READ_ALL];
//# sourceMappingURL=support.js.map